export const T = {
  en_GB: {
    search: "Search...",
    selectAll: "Select All",
    clearAll: "Clear All",
    noOptionsFound: "No options found",
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    search: "Søk...",
    selectAll: "Velg alle",
    clearAll: "Fjern alle",
    noOptionsFound: "Ingen alternativer funnet",
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
